import script from "./PaRecap.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaRecap.vue?vue&type=script&setup=true&lang=ts"

import "./PaRecap.vue?vue&type=style&index=0&id=37842197&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37842197"]])

export default __exports__